import React, { Component } from 'react'

export class RecentItem extends Component {
    render() {
        return (
            <div className='recent--content_box'>
                <div className="recent--image_box">
                    <img src={"./img/TrendImg/" + this.props.item.foto} />
                    <div className='recent--category'><h3>{this.props.item.category}</h3></div>
                </div>
                <div className='recent--title__content'>
                    <h2>{this.props.item.title}</h2>
                    <div className="blog_title--content">
                        <h3>{this.props.item.date}</h3>
                    </div>
                </div>
            </div>
        )
    }
}

export default RecentItem

